var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticStyle:{"visibility":"hidden"},on:{"click":function($event){return _vm.drawGraph()}}},[_vm._v("refresh")]),_c('div',{staticClass:"graph-container"},[_c('div',{ref:"chart",staticClass:"chart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }